// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DatasheetsResultDatasheet{position:relative}", "",{"version":3,"sources":["webpack://./src/main/js/modules/datasheets/components/result/components/datasheet/datasheet.styles.scss"],"names":[],"mappings":"AAAA,2BACE,iBAAA","sourcesContent":[".DatasheetsResultDatasheet {\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
